let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cBkmk")).then(() => parcelRequire('lnnie'));